import React from "react";
import {
  AppLayout as CloudscapeAppLayout,
  SideNavigation,
  TopNavigation,
} from "@cloudscape-design/components";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "src/providers";
import { useUIStore } from "src/store";
import { Mode } from "@cloudscape-design/global-styles";
import { FinergyFloatingMenu } from "../Header/FinergyFloatingMenu";
import Breadcrumb from "../common/Breadcrumb";
import { useBreadcrumbs } from "src/hooks/useBreadcrumbs";

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const { mode, setMode } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { sideNavigationOpen, setSideNavigationOpen } = useUIStore();
  const breadcrumbs = useBreadcrumbs();

  const navigationItems = [
    {
      type: "link" as const,
      text: "Dashboard",
      href: "/dashboard",
    },
  ];

  const handleNavigationFollow = (event: any) => {
    event.preventDefault();
    const href = event.detail.href;
    if (href && href.startsWith("/")) {
      navigate(href);
      setSideNavigationOpen(false);
    }
  };

  const handleHeaderClick = (event: any) => {
    event.preventDefault();
    navigate("/dashboard");
    setSideNavigationOpen(false);
  };

  const toggleTheme = () => {
    setMode(mode === Mode.Light ? Mode.Dark : Mode.Light);
  };

  return (
    <>
      <div id="top-navigation">
        <TopNavigation
          identity={{
            href: "/dashboard",
            title: "FinSpace",
            onFollow: handleHeaderClick,
          }}
          utilities={[
            {
              type: "button",
              text: mode === Mode.Light ? "Dark mode" : "Light mode",
              onClick: toggleTheme,
            },
          ]}
        />
      </div>
      <CloudscapeAppLayout
        navigation={
          <SideNavigation
            activeHref={location.pathname}
            header={{ href: "/dashboard", text: "FinSpace" }}
            onFollow={handleNavigationFollow}
            items={navigationItems}
          />
        }
        maxContentWidth={Number.MAX_VALUE}
        navigationOpen={sideNavigationOpen}
        onNavigationChange={({ detail }) => setSideNavigationOpen(detail.open)}
        toolsHide
        disableContentPaddings
        {...(breadcrumbs.length > 1 && { breadcrumbs: <Breadcrumb /> })}
        content={children}
      />
    </>
  );
};

export default AppLayout;
